var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.customer.id || _vm.createMode)?_c('div',[_c('customer-edit',{attrs:{"customer":_vm.customer,"title":_vm.title},on:{"saved":_vm.updateCustomer}})],1):_c('loading-content',{attrs:{"loading":_vm.loading,"empty-icon":"person_outline","empty-label":"Cliente no encontrado."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Customers/Update.vue